module.exports = __webpack_public_path__ + "img/10_James.20bb8cdd.jpg";